/*
 * @Author: 陈传勋 593837024@qq.com
 * @Date: 2022-05-07 18:13:30
 * @LastEditors: 陈传勋 593837024@qq.com
 * @LastEditTime: 2023-03-10 09:14:15
 * @FilePath: /xlian-web-platform/src/utils/constants.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const SYSTEM_SUCCESS = 200
/** 系统出错 */
export const SYSTEM_ERROR = 999
/** 请登录 */
export const SYSTEM_UNLOGIN_ERROR = 998
/** 参数错误 */
export const SYSTEM_PARAMETER_ERROR = 997
/** 认证失败 */
export const SYSTEM_AUTH_FAIL = 401
/** 商户暂存不存在 */
export const MERCHANT_TEMP_NOT_EXIST = 64010302
/** 平台类型 */
export const PLATFORM_TYPE = 'web'
/** 业务类型 */
export const BIZ_TYPE = 'emiWeb'
/** 系统版本 */
export const RELEASE_VERSION = process.env.VUE_APP_VERSION
/** OSS地址 */
export const OSS_BASE_URL = process.env.VUE_APP_OSS_URL
/** 药师职称选项 */
export const pharmacistTitleList = [
  {
    label: '初级药师',
    value: 1
  },
  {
    label: '初级中药师',
    value: 2
  },
  {
    label: '主管药师',
    value: 3
  },
  {
    label: '主管中药师',
    value: 4
  },
  {
    label: '副主任药师',
    value: 5
  },
  {
    label: '副主任中药师',
    value: 6
  },
  {
    label: '主任药师',
    value: 7
  },
  {
    label: '主任中药师',
    value: 8
  }
]

// 医生审核状态
export const CHECK_STATUS = {
  UNCOMMIT: 10,
  PRE_CHECK: 20,
  OK: 30,
  NO: 40
}
